module.exports = __webpack_public_path__ + "static/media/blocked-players-icon.4b1dcba9.svg";